export async function baseUrlEncoder(url: string, outputFormat = 'image/png', width = 600, height = 800): Promise<any> {
    if (url.indexOf('base64') !== -1) { return url; } else {
        const result = await new Promise(function (resolve, reject) {
            let canvas: any = document.createElement('CANVAS');
            const ctx = canvas.getContext('2d');
            const img = new Image;

            img.crossOrigin = 'Anonymous'; // 重点！设置image对象可跨域请求
            img.onload = function () {
                // scale
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);
                const dataURL = canvas.toDataURL(outputFormat);
                canvas = null;
                resolve(dataURL);
            };
            img.src = url.replace('https://files.realjaja.com/', 'https://realjaja-files.oss-us-west-1.aliyuncs.com/');
            // console.log(url);
            // img.src = 'https://placekitten.com/1000/300';
        });
        return result;
    }
}

export function arrayBufferToBase64(bytes: any) {
    const len = bytes.byteLength;
    let binary = '';
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

export async function baseUrlEncoderGreyScale(url: string, outputFormat = 'image/png', width = 600, height = 800): Promise<any> {
    if (url.indexOf('base64') !== -1) { return url; } else {
        const result = await new Promise(function (resolve, reject) {
            let canvas: any = document.createElement('CANVAS');
            const ctx = canvas.getContext('2d');
            const img = new Image;

            img.crossOrigin = 'Anonymous'; // 重点！设置image对象可跨域请求
            img.onload = function () {
                // scale
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);
                const imgData = ctx.getImageData(0, 0, width, height);
                const pixels = imgData.data;
                for (let i = 0; i < pixels.length; i += 4) {

                    const lightness: any = parseInt(`${(pixels[i] + pixels[i + 1] + pixels[i + 2]) / 3}`, 10);

                    pixels[i] = lightness;
                    pixels[i + 1] = lightness;
                    pixels[i + 2] = lightness;
                }
                ctx.putImageData(imgData, 0, 0);
                const dataURL = canvas.toDataURL(outputFormat);
                canvas = null;
                resolve(dataURL);
            };
            img.src = url.replace('https://files.realjaja.com/', 'https://realjaja-files.oss-us-west-1.aliyuncs.com/');
            // console.log(url);
            // img.src = 'https://placekitten.com/1000/300';
        });
        return result;
    }
}

export async function dataUrlToGray(imgURl: any, w = 600, h = 800) {
    const img = new Image;
    img.src = imgURl;

    const result = await new Promise(function (resolve, reject) {
        img.onload = function () {
            const canvas = document.createElement('canvas');
            const canvasContext: any = canvas.getContext('2d');
            canvasContext.webkitImageSmoothingEnabled = false;
            canvasContext.mozImageSmoothingEnabled = false;
            canvasContext.imageSmoothingEnabled = false;
            img.crossOrigin = 'Anonymous'; // 重点！设置image对象可跨域请求

            canvas.width = w;
            canvas.height = h;

            canvasContext.drawImage(img, 0, 0);
            const imgPixels = canvasContext.getImageData(0, 0, w, h);
            for (let y = 0; y < imgPixels.height; y++) {
                for (let x = 0; x < imgPixels.width; x++) {
                    const i = (y * 4) * imgPixels.width + x * 4;
                    const avg = (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3;
                    imgPixels.data[i] = avg;
                    imgPixels.data[i + 1] = avg;
                    imgPixels.data[i + 2] = avg;
                }
            }
            canvasContext.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
            resolve(canvas.toDataURL());
        };
    });
    return result;
}


// const imgData = ctx.drawImage(img, 0, 0, width, height);
// const pixels = imgData.data;
// for (let i = 0; i < pixels.length; i += 4) {

//     const lightness: any = parseInt((pixels[i] + pixels[i + 1] + pixels[i + 2]) / 3);

//     pixels[i] = lightness;
//     pixels[i + 1] = lightness;
//     pixels[i + 2] = lightness;
// }
// ctx.putImageData(imgData, 0, 0);

export function dataURItoBlob(dataURI: string) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
}

export function dataURItoPDF(dataURI: string) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1]);

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'application/pdf' });
}

export function capitalize(str: string) {
    if (str === '') { return ''; }
    const init = str[0].toUpperCase();
    return init + str.slice(1, str.length);
}

export async function blobToBase64(blob: Blob): Promise<any> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
            const base64data = reader.result;
            resolve(base64data!);
        };
    });
}
